export const s = {
  name: 'Ben Hiç',
  pitch: 'Gizlice “yaptım” ya da “yapmadım” de, sonra kimin yaptığı ortaya çıksın',
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    categories: 'Kategoriler',
    categoriesHint: '+18 kategoriler varsayılan olarak kapalıdır.',
    adultHint: '+18 kategoriler açık cinsel içerik içerir; yalnızca yetişkinler içindir.',
    coupleHint: 'Çift odası: partnerinle ikiniz için. Pas hakkı her zaman var; durmak isteyen durdurur.',
    lives: 'Can (parmak)',
    livesHint: (n: number) => (n === 0 ? 'Kimse elenmez; oyun tur sayısıyla ya da oda sahibi bitirince biter.' : `“Yaptım” diyen 1 can kaybeder. ${n} canı biten elenir ama izlemeye devam eder.`),
    off: 'Kapalı',
    on: 'Açık',
    anonymous: 'İsimsiz açıklama',
    anonymousHint: 'Açıkken yalnızca kaç kişinin yaptığı gösterilir, kim olduğu gösterilmez. Can sistemi kapanır.',
    seconds: 'Cevap süresi',
    secondsOpt: (n: number) => (n === 0 ? 'Süresiz' : `${n} sn`),
    secondsHint: (n: number) => (n === 0 ? 'Herkes cevaplayınca açılır.' : 'Herkes cevaplayınca ya da süre bitince açılır.'),
    rounds: 'Tur sayısı',
    roundsOpt: (n: number) => (n === 0 ? 'Sınırsız' : String(n)),
    unlimitedHint: 'Oda sahibi bitirene kadar sürer.',
    addTitle: 'Cümle ekle',
    addHint: 'Eklediğin cümle “Arkadaş cümleleri” kategorisine girer.',
    addOpen: 'Kendi cümleni yaz',
    prefix: 'Ben hiç',
    placeholder: 'sınavda kopya çekmedim',
    save: 'Cümleyi ekle',
    saving: 'Ekleniyor…',
    saved: (t: string) => `Eklendi: ${t}`,
    saveFailed: 'Eklenemedi. Bağlantını kontrol edip tekrar dene.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Ben Hiç · Tur ${n}/${total}` : `Ben Hiç · Tur ${n}`),
    lead: 'Ben hiç…',
    secs: (n: number) => `${n} sn`,
    noAnswer: 'Sen cevap vermedin',
    doerLives: (n: number) => `${n} parmak`,
    storyteller: (nick: string) => `${nick}, hikâyeyi anlatma sırası sende!`,
    did: 'Yaptım',
    didNot: 'Yapmadım',
    answeredNote: 'Cevabın gizli. Açılana kadar fikrini değiştirebilirsin.',
    askNote: 'Cevabını kimse görmez; herkes cevaplayınca açılır.',
    eliminatedNote: 'Canın bitti. Oyunu izlemeye devam ediyorsun.',
    lateNote: 'Sıradaki cümlede sen de cevaplayabilirsin.',
    waiting: (n: number, total: number) => `${n}/${total} kişi cevapladı`,
    skip: (votes: number, needed: number) => (votes ? `Bu cümleyi atla (${votes}/${needed})` : 'Bu cümleyi atla'),
    skipUndo: (votes: number, needed: number) => `Atlama oyumu geri al (${votes}/${needed})`,
    revealNow: 'Cevapları şimdi aç',
    nextStatement: 'Başka cümle getir',
    next: 'Sıradaki cümle',
    toResults: 'Sonuçları gör',
    waitHost: 'Oda sahibi sıradaki cümleye geçecek.',
    finalNote: 'Son tur bitti. Sonuçlar birazdan açılıyor.',
    nobody: 'Kimse yapmamış. Temiz bir grup.',
    everyone: 'Herkes yapmış.',
    didCount: (n: number, total: number) => `${total} kişiden ${n} kişi yaptı`,
    noAnswers: 'Kimse cevap vermedi.',
    unanswered: (n: number) => `${n} kişi cevap vermedi`,
    eliminated: (names: string) => `${names} elendi`,
    you: 'sen',
    answered: 'cevapladı',
    waitingTag: 'düşünüyor',
    eliminatedTag: 'elendi',
    yourAnswer: (a: 'did' | 'didNot') => (a === 'did' ? 'Sen: yaptım' : 'Sen: yapmadım'),
    players: 'Oyuncular',
    leader: (nick: string, n: number) => `Şu ana kadar en çok yapan: ${nick} (${n} kez)`,
    history: 'Tur geçmişi',
    historyEmpty: 'İlk cümle açılınca burada görünecek.',
    lives: (n: number) => `${n} parmak kaldı`,
    more: 'Tur geçmişi ve ayarlar',
  },
  podium: {
    title: 'Oyun bitti',
    winner: (names: string) => `${names} ayakta kaldı`,
    noneLeft: 'Kimse ayakta kalmadı',
    mostDid: (nick: string) => `En çok yapan: ${nick}`,
    cleanest: (nick: string) => `En masum: ${nick}`,
    summary: (rounds: number) => `${rounds} cümle açıldı`,
    anonymousNote: 'İsimsiz oynadınız; kişi başı sayılar gösterilmez.',
    me: (did: number, didNot: number) => `Sen ${did} kez yaptım, ${didNot} kez yapmadım dedin.`,
    hottest: 'En çok yapılan',
    hottestCount: (n: number, total: number) => `${total} kişiden ${n} kişi`,
    did: 'Yaptım',
    didNot: 'Yapmadım',
    lives: 'Can',
    back: 'Lobiye dönülüyor…',
    gameOver: 'Oyun bitti',
    livesLeft: 'parmak kaldı',
    timesDid: 'kez yaptı',
    mostDidCaption: 'En çok yapan',
    cleanestCaption: 'En masum',
    timesShort: (n: number) => `${n} kez`,
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Cümleyi oku', 'Her turda bir cümle çıkar: “Ben hiç … yapmadım.”'],
      ['Gizlice cevapla', 'Yaptıysan “Yaptım”, yapmadıysan “Yapmadım”a bas. Kimse cevabını açılmadan göremez.'],
      ['Açıklama', 'Herkes cevaplayınca ya da süre bitince kimlerin yaptığı açılır. Hikâyeyi anlatmak serbest.'],
      ['Canlar', 'Can sistemi açıksa her “yaptım” bir parmak indirir. Parmakları biten elenir, son kalan kazanır.'],
    ] as [string, string][],
  },
};
